import { css } from 'lit';

export const style = css`
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		height: 100%;
	}

	* {
		box-sizing: border-box;
	}

	.controls {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex: 0;
		border-bottom: 1px solid var(--og-bucket-border-color);
	}

	.body {
		flex: 1;
		overflow: auto;
		position: relative;
	}

	#empty {
		flex: 1;
	}

	/* the toolbar shrinks with the editor and scrolls its items instead of overflowing */
	.controls > og-toolbar {
		flex: 0 1 auto;
		min-width: 0;
	}

	#history {
		flex: 0 1 250px;
		min-width: 0;
		padding-right: 4px;
	}

	.controls > rp-editor-settings-menu {
		flex: 0 0 auto;
	}

	#ddHistory {
		width: 100%;
		height: 24px;
	}

	og-close {
		width: 20px;
		margin-right: 6px;
	}
`;
